module.exports = __webpack_public_path__ + "img/io_excel.045719f8.png";